<div class="modal-backdrop" *ngIf="show" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="text-center">
          <!-- Unpublish Icon -->
          <div class="unpublish-icon-container mb-4">
            <div class="unpublish-icon-background">
              <i class="fas fa-download"></i>
            </div>
          </div>

          <!-- Main Message -->
          <h5 class="modal-title mb-3">
            Are you sure you want to unpublish the template "{{
              templateName
            }}"?
          </h5>

          <!-- Warning Message -->
          <p class="warning-message text-muted">
            Once unpublished, this template will no longer be<br />
            available for service managers to create new services.<br />
            Existing services using this template will not be affected.
          </p>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="onCancel()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">
          Yes, Unpublish
        </button>
      </div>
    </div>
  </div>
</div>
